import React, { useState } from "react";
import Search from "../Search/Search";
import "./style.css"
const CENModalUi = ({
  data,
  setShowModal,
  setCenSearch,
  cenSearch,
  setTableQaury,
  tableQaury,
  onSave,
  selectedCEN,
  setSelectedCEN,
  handleCheckboxChange
}) => {
  return (
    <div>
      <div className="modal fade show d-block cen-modal-overlay" id="modal-danger">
        <div
          className="modal-dialog d-flex align-items-center"
          style={{ height: "calc(100vh - 72px)",width:"400px" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">CEN</h4>
              <button
                type="button"
                className="close"
                onClick={() => setShowModal(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="d-flex mb-3">
                <Search
                  setTableQaury={setCenSearch}
                  tableQaury={cenSearch}
                  placeHolder={"Search By CEN"}
                  buttonName={""}
                  buttonBoolean={false}
                  linkPath={""}
                  // backgroundColor={"#F9FAFB"}
                />
                
              </div>
              <div className="data-box">
                {data?.map((val) => (
                  <div key={val.id} className="form-check list-cen">
                    <input
                      type="checkbox" // Change input type to "radio"
                      className="form-check-input"
                      id={`cen-${val.id}`}
                      checked={selectedCEN === val.id}
                      onChange={() => handleCheckboxChange(val.id)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`cen-${val.id}`}
                    >
                      {val.name}
                    </label>
                  </div>
                ))}
              </div>
            </div>
              <div className="modal-footer">
              <button
                  className="btn-primary"
                  style={{ height: "fit-content" }}
                  // onClick={onSave}
                  onClick={() => {
                    if (data.length > 0) {
                      onSave();
                    }
                  }}
                >
                  Save
                </button>
              </div>
          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>
      {/* /.modal */}
    </div>
  );
};

export default CENModalUi;
